module.exports = __webpack_public_path__ + "img/community_no_image.bb768288.svg";